<template>
	<div>
		<div slot="modal-body">
			<b-row>
				<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						:label="$t('pending.regDate')"
					>
						<b-input-group size="sm">
							<masked-input
								v-model="item.regDate"
								class="form-control form-control-sm "
								mask="11-11-1111"></masked-input>
							<b-input-group-addon>
								<b-button size="sm" disabled>
									<i class="fa fa-calendar"></i>
								</b-button>
							</b-input-group-addon>
						</b-input-group>
					</b-form-group>

				</b-col>
				<b-col cols="12">
					<b-form-group
						size="sm"
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
					>
						<template slot="label">
							{{ $t('pending.fio') }} <span class="text-danger">*</span>
						</template>
						<b-form-input name="fio" v-validate="{required: true}" v-model="item.fio" size="sm"
									  autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group
						size="sm"
						breakpoint="lg"
						label-size="sm"
						label-cols="4"

					>
						<template slot="label">
							{{ $t('pending.rosxojdeniya')}} <span class="text-danger">*</span>
						</template>
						<b-form-select v-model="item.shortageTypeId"
									   :value-field="'id'"
									   name="shortageTypeId"
									   v-validate="{required: true}"
									   :text-field="'name'"
									   :options="list"
									   size="sm">
							<template slot="first">
								<option :value="null">-- {{$t('pending.select')}} --</option>
							</template>
						</b-form-select>
					</b-form-group>
				</b-col>
				<!--<p v-if="message" class="text-danger ml-5">Введите правильную цифру!</p>-->
				<!--<b-col v-for="lostItem in item.adjustmentItems" :key="lostItem.itemId" cols="12">-->

				<!--<b-form-group size="sm"-->
				<!--breakpoint="lg"-->
				<!--label-size="sm"-->
				<!--label-cols="4"-->
				<!--:label="lostItem.itemName	">-->
				<!--<b-row>-->
				<!--<b-col>{{ lostItem.count }} {{lostItem.unit}}</b-col>-->
				<!--<b-col><b-input-group size="sm">-->
				<!--<b-form-input v-model="lostItem.qty"  size="sm" autocomplete="off"></b-form-input>-->
				<!--<b-input-group-addon>-->
				<!--<b-button size="sm" disabled>-->
				<!--{{ lostItem.unit }}-->
				<!--</b-button>-->
				<!--</b-input-group-addon>-->
				<!--</b-input-group></b-col>-->
				<!--</b-row>-->
				<!--</b-form-group>-->

				<!--</b-col>-->
				<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">
					<thead>
					<tr>
						<th style="width: 30px;text-align: center">№</th>
						<th>Товар</th>
						<th colspan="2">Количество</th>
						<th style="width: 230px;">Количество</th>
					</tr>
					</thead>
					<tr v-for="lostItem,index in item.adjustmentItems" :key="lostItem.itemId" cols="12">
						<td style="text-align: center">
							{{ index + 1 }}
						</td>
						<td>{{lostItem.itemName}}/ <strong>{{ lostItem.artikul}}</strong>/{{lostItem.color}}/{{lostItem.size}}
							<strong>{{lostItem.barcode}}</strong></td>
						<td colspan="2">
							{{ lostItem.count }} {{lostItem.unit}}
						</td>
						<td>
							<b-col>
								<b-input-group size="sm">
									<b-form-input v-model="lostItem.qty"
												  size="sm" autocomplete="off" type="number"></b-form-input>
									<b-input-group-addon>
										<b-button size="sm" disabled>
											{{ lostItem.unit }}
										</b-button>
									</b-input-group-addon>
								</b-input-group>
							</b-col>
						</td>
					</tr>
				</table>

				<b-col cols="12">
					<b-form-group
						size="sm"
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						:label="$t('incomes.comment')"
					>
						<b-textarea v-model="item.comment"></b-textarea>
					</b-form-group>
				</b-col>
			</b-row>
		</div>

		<div slot="modal-footer">
			<b-button
				variant="success"
				size="sm"
				class="float-right ml-2"
				@click="submitAdj"
			>
				Да
			</b-button>

			<b-button
				variant="primary"
				size="sm"
				class="float-right"
				@click="cancelAdj"
			>
				Отмена
			</b-button>
		</div>

	</div>
</template>

<script>
	import MaskedInput from 'vue-masked-input'
	import moment from 'moment'
	import ReferencesService from "../../../../../services/references.sevice";

	export default {
		name: 'Adjustment',

		props: {
			documentId: {},
			items: {
				type: Array,
			}
		},

		components: {
			MaskedInput
		},
		data() {
			return {
				item: {
					regDate: null,
					comment: null,
					fio: null,
					linkedDocumentId: null,
					shortageTypeId: null,
					adjustmentItems: []
				},
				list: [],
				message: false,
			}
		},

		created() {

			this.item.regDate = moment().format('DD-MM-YYYY');
			this.loadList();
			this.item.adjustmentItems = this.items;

		},

		methods: {
			loadList() {
				ReferencesService.getReferenceChildren(`shortage`).then(response => {
					this.list = response.data;
				})
			},
			submitAdj() {
				this.$validator.validate().then(valid => {
					if (valid) {
						this.item.linkedDocumentId = this.documentId;
						this.item.shortageTypeId = this.item.shortageTypeId;
						this.$emit('ok', this.item);
					} else {
						this.$vs.notify({
							title: this.$t('words.error'),
							text: 'Заполните все обязательное поле',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					}
				});

			},
			cancelAdj() {
				this.$emit('cancel');
			},
			checkValid() {
				let valid = true;
				this.item.adjustmentItems.forEach(item => {
					if (item.count < item.qty || item.qty < 0) {
						valid = false
					}
				});

				if (!valid) {
					this.message = true
					return false
				} else {
					this.message = false
					return true

				}
			}
		},

		computed: {},
		watch: {
			item: {
				deep: true,
				handler() {
					if (this.checkValid()) {
						this.message = false
					} else {
						this.message = true
					}
				}
			}
		}
	}
</script>

<style scoped>
	.text-danger{
		margin-left: 10px;
	}
</style>
